/* eslint-disable global-require */

import adminPaths from './admin';
// The top-level (parent) route
const routes = {
  path: '',

  // Keep in mind, routes are evaluated in order
  children: [
    {
      path: '',
      load: () => import(/* webpackChunkName: 'home' */ './home'),
    },
    {
      path: '/subscribe',
      load: () => import(/* webpackChunkName: 'subscribe' */ './subscribe'),
    },
    {
      path: '/about',
      load: () => import(/* webpackChunkName: 'about' */ './about'),
    },
    {
      path: '/terms',
      load: () => import(/* webpackChunkName: 'terms' */ './terms'),
    },
    {
      path: '/privacy',
      load: () => import(/* webpackChunkName: 'privacy' */ './privacy'),
    },
    {
      path: '/admin',
      children: adminPaths,
    },
    {
      path: '/events',
      load: () => import(/* webpackChunkName: 'events' */ './events'),
    },
    {
      path: '/forward',
      children: [
        {
          path: '/massmails/:id',
          load: () =>
            import(
              /* webpackChunkName: 'massmailsForward' */ './massmails/forward'
            ),
        },
      ],
    },
    {
      path: '/publications',
      children: [
        {
          path: '/:id',
          children: [
            {
              path: '',
              load: () =>
                import(/* webpackChunkName: 'publication' */ './publication'),
            },
            {
              path: '/news',
              children: [
                {
                  path: '/:id',
                  load: () =>
                    import(/* webpackChunkName: 'newsRead' */ './newsRead'),
                },
                {
                  path: '/category/:cat',
                  load: () =>
                    import(
                      /* webpackChunkName: 'publication' */ './publication'
                    ),
                },
                {
                  path: '/tags/:tag',
                  load: () => import(/* webpackChunkName: 'tags' */ './tags'),
                },
              ],
            },
          ],
        },
        {
          path: '/:id/archives/:month',
          load: () =>
            import(/* webpackChunkName: 'newsArchive' */ './newsArchive'),
        },
        {
          path: '/:id/tags/:tag',
          load: () => import(/* webpackChunkName: 'tags' */ './tags'),
        },
        {
          path: '/:id/archives',
          load: () => import(/* webpackChunkName: 'archives' */ './archives'),
        },
      ],
    },
    {
      path: '/news', // this path is for news-related usecases that not entirely associated with a single publication
      children: [
        {
          path: '/search/:phrase',
          load: () =>
            import(/* webpackChunkName: 'newsSearch' */ './newsSearch'),
        },
      ],
    },
    {
      path: '/suppliers',
      load: () => import(/* webpackChunkName: 'suppliers' */ './suppliers'),
    },
    {
      path: '/users/unsubscribe',
      children: [
        {
          path: '',
          load: () =>
            import(/* webpackChunkName: 'unsubscribe' */ './unsubscribe'),
        },
        {
          path: '/:id',
          load: () =>
            import(/* webpackChunkName: 'unsubscribe' */ './unsubscribe'),
        },
      ],
    },
    // Wildcard routes, e.g. { path: '(.*)', ... } (must go last)
    {
      path: '(.*)',
      load: () => import(/* webpackChunkName: 'not-found' */ './not-found'),
    },
  ],

  async action({ next }) {
    // Execute each child route until one of them return the result
    const route = await next();

    // Provide default values for title, description etc.
    route.title = `${route.title || 'Home Page'}`;
    route.description = route.description || '';

    return route;
  },
};

// The error page is available by permanent url for development mode
if (__DEV__) {
  routes.children.unshift({
    path: '/error',
    action: require('./error').default,
  });
}

export default routes;
